exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main[data-v-635014e0] {\r\n    border: 1px solid rgba(25, 118, 210, 0.3);\n}\n.header[data-v-635014e0] {\r\n    border-bottom: 1px solid rgba(25, 118, 210, 0.3);\r\n    background-color: rgba(25,118,210,0.1);\n}\r\n\r\n", ""]);

// exports
